import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {PlatformService} from './services/platformService';
import {StoreModule} from '@ngrx/store';
import {metaReducers, reducers} from './reducers';
import {environment} from '../environments/environment';
import {FormsModule} from '@angular/forms';
import {AllowOriginInterceptor} from './services/allowOriginInterceptor';
import {MomentModule} from 'ngx-moment';
import 'moment/locale/de';
import {SopiScrollModule} from '../sopi/components/sopi-scroll/sopi-scroll.module';
import {EffectsModule} from '@ngrx/effects';
import {ClipboardModule} from 'ngx-clipboard';
import {JsonEditorPageModule} from './mandanten/modale/json-editor.module';
import {DocumentService} from '../sopi/providers/document.serivce';
import {ImageService} from '../sopi/providers/image.service';
import {SopiComponentsModule} from './shared/sopi-components/sopi-components.module';
import {PipesModule} from '../sopi/pipes/pipes.module';
import {ClientsModule} from './clients.module';
import {HankoModule} from "../sopi/hanko";
import {HankoLoginPage} from "../sopi/hanko-login-page/hanko-login.page";
import {loginSucceessFn} from "./app.login-success";

@NgModule({
    declarations: [AppComponent, HankoLoginPage],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot({
            mode: 'md',
            // animated: true
        }),
        AppRoutingModule,
        HankoModule.forRoot({
            hankoUrl: environment.hankoUrl,
            apiUrl: environment.appConfig.apiUrl,
            loginCheckApiUrl: 'api/account/logincheck',
            logoutApiUrl: 'api/account/logout',
            loginRoute: environment.loginRoute,
            successFn: loginSucceessFn
            // postLoginRoute: '/'
        }),
        ClipboardModule,
        MomentModule.forRoot(),
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
            }
        }),
        // !environment.production ? StoreDevtoolsModule.instrument() : [],
        EffectsModule.forRoot([]),
        FormsModule,
        ClientsModule.forRoot(environment.appConfig.apiUrl),
        SopiScrollModule,
        JsonEditorPageModule.forRoot(),
        SopiComponentsModule.forRoot(),
        PipesModule,
    ],
    providers: [
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        // OAuthService,
        PlatformService,
        DocumentService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AllowOriginInterceptor,
            multi: true
        },
        ImageService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
